<template>
    <v-flex>
        <v-progress-linear
            indeterminate
            v-if="loading"
            color="secondary"
        />
        <v-stepper v-if="!loading" v-model="stepper">
            <v-stepper-header>
                <v-stepper-step
                    :complete="stepper > 1"
                    step="1"
                    color="secondary"
                    :class="stepper > 1 ? 'give-me-a-pointer' : ''"
                    @click="goToStep(1)"
                >
                    A betöltött gépjármű adatai
                </v-stepper-step>

                <v-divider/>
                <v-stepper-step
                    :complete="stepper > 2"
                    step="2"
                    color="secondary"
                    :class="stepper > 2 ? 'give-me-a-pointer' : ''"
                    @click="goToStep(2)"
                    v-if="!skipCarInsurableExtras"
                >
                    Biztosítani kívánt felszereltség
                </v-stepper-step>

                <v-divider/>

                <v-stepper-step
                    :step="skipCarInsurableExtras ? 2 : 3"
                    color="secondary"
                >
                    Kiválasztás
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>

                <v-stepper-content step="1">
                    <LoadedCarData
                        v-if="loadedCarData"
                        :loaded-car-data="loadedCarData"
                    />
                    <div style="margin-top: 35px;">
                        <v-btn
                            color="primaryButtonColor"
                            style="color: var(--v-primaryButtonTextColor-base);"
                            @click="$emit('inkabb-uj-gepjarmu')"
                            text
                        >
                            Másik gépjármű kiválasztása
                        </v-btn>
                        <v-btn
                            color="secondaryButtonColor"
                            style="color: var(--v-secondaryButtonTextColor-base);"
                            @click="stepper = 2"
                            v-if="currentStage > 1"
                        >
                            {{
                                skipCarInsurableExtras
                                    ? 'Tovább a jármű kiválasztásához'
                                    : 'Tovább a biztosítani kívánt felszereltség kiválasztásához'
                            }}
                        </v-btn>
                    </div>
                </v-stepper-content>

                <v-stepper-content step="2" v-if="!skipCarInsurableExtras">
                    <v-dialog
                        width="600"
                        :value="showExtrasWarning"
                        @input="showExtrasWarning = false"
                    >
                        <v-card>
                            <v-card-text class="title">
                                <p class="pt-5">
                                    Kérjük bizonyosodjon meg róla, hogy minden biztosítani kívánt extra megjelölésre
                                    került.
                                    Hiányos lista esetén a biztosító nem téríti meg a listán nem szereplő tételeket.
                                </p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primaryButtonColor"
                                    style="color: var(--v-primaryButtonTextColor-base);"
                                    class="button"
                                    @click="showExtrasWarning = false"
                                >
                                    Vissza
                                </v-btn>
                                <v-btn
                                    color="secondaryButtonColor"
                                    style="color: var(--v-secondaryButtonTextColor-base);"
                                    class="button"
                                    @click="() => {
                                        this.stepper = 3;
                                        this.showExtrasWarning = false
                                    }"
                                >
                                    Minden rendben, kiválasztom a járművet.
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <CarInsurableExtras :eurotax-vehicle-type="eurotaxVehicleType" />
                    <div style="margin-top: 35px;">
                        <v-btn
                            color="secondaryButtonColor"
                            style="color: var(--v-secondaryButtonTextColor-base);"
                            class="button"
                            @click="stepper = 1"
                            text
                        >
                            Vissza
                        </v-btn>
                        <v-btn
                            color="secondaryButtonColor"
                            style="color: var(--v-secondaryButtonTextColor-base);"
                            class="button"
                            @click="showExtrasWarning = true"
                        >
                            Tovább
                        </v-btn>
                    </div>
                </v-stepper-content>

                <v-stepper-content :step="skipCarInsurableExtras ? 2 : 3">
                    <h3>Válassza ki a listából a biztosítani kívánt gépjárművet</h3>
                    <div>
                        <div class="db-field">
                            {{ getFilteredCarDb }} találat<span
                            v-if="!showAll && getFilteredCarDb > 15">, {{ maxVisibleCars }} látható.
                                    <span class="show-all-text" @click="chShowAll()">Mutasd az összeset!</span>
                                    </span>
                        </div>

                        <div style="margin: 25px 0;">
                            <v-expansion-panels v-model="gyorsSzuroOpened" focusable style="margin: 15px 0px">
                                <v-expansion-panel>
                                    <v-expansion-panel-header v-html="expansionHeader"/>
                                    <v-expansion-panel-content>
                                        <FilterExtras
                                            :cars="filteredCars"
                                            @filter-car="filterCar"
                                            :reset-selected="resetSelectedExtras"
                                            @reseted="resetSelectedExtras = false"
                                        />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                            <v-btn
                                color="orange"
                                class="button"
                                @click="gyorsBtnClick"
                            >
                                GyorsSzűrő
                                <v-icon v-if="!(gyorsSzuroOpened === 0)">{{ icons.mdiFilter }}</v-icon>
                                <v-icon v-if="gyorsSzuroOpened === 0">{{ icons.mdiClose }}</v-icon>
                            </v-btn>
                        </div>

                        <div class="scrollable-box">
                            <CarRow
                                v-model="eurotaxcode"
                                v-for="(car, index) in visibleCars"
                                :car="car"
                                :eurotaxcode="eurotaxcode"
                                :key="index"
                            />
                        </div>
                    </div>
                    <v-btn
                        color="primary"
                        class="button"
                        @click="stepper = skipCarInsurableExtras ? 1 : 2"
                        text
                    >
                        Vissza
                    </v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-flex>
</template>

<script>
import lodash from 'lodash';
import {
    mdiFilter,
    mdiClose,
} from '@mdi/js';
import { eurotaxService } from '../../services/EurotaxService';
import EventBus from '../../modules/EventBus';
import CarRow from '../Eurotax/CarRow.vue';
import FilterExtras from '../Eurotax/FilterExtras.vue';
import { EUROTAX_TYPE_CAR, findSpecialExtras } from '../Eurotax/utilities';
import CarInsurableExtras from '../Eurotax/CarInsurableExtras.vue';
import gepjarmutorzsService from '../../services/GepjarmutorzsService';
import LoadedCarData from './LoadedCarData.vue';
import { MOTOR, SZGK } from '../../modules/Gepjarmu';

export default {
    name: 'EurotaxLoader',

    components: {
        CarInsurableExtras,
        FilterExtras,
        CarRow,
        LoadedCarData,
    },
    props: {
        rendszam: {
            required: true,
            type: String,
        },
        skipCarInsurableExtras: {
            type: Boolean,
            default: false,
        },
        eurotaxVehicleType: {
            type: Number,
            default: EUROTAX_TYPE_CAR,
        },
    },

    watch: {
        eurotaxcode() {
            this.$store.commit('setProp', {
                path: 'release_eurotax_ujkori_ertek_lock',
                value: true,
            });
            this.$emit('input', this.eurotaxcode);
        },
        filteredCars() {
            this.visibleCars = this.getVisibleVehicleList(this.filteredCars);
        },
    },

    mounted() {
        this.loading = true;
        gepjarmutorzsService.getGepjarmu(
            this.$store.getters.companyId,
            this.rendszam,
        )
            .then((response) => {
                const carData = lodash.cloneDeep(response.data[0]);
                this.loadedCarData = carData;

                if (carData) {
                    eurotaxService.vehicleModelGroupsByMaker(
                        carData.gyartmany_kod,
                        carData.fajta === MOTOR ? MOTOR : SZGK,
                        carData.gyartev,
                    )
                        .then((vehicleModelGroupsByMakerResponse) => {
                            let gyartmanyHash = null;
                            vehicleModelGroupsByMakerResponse.data.forEach((element) => {
                                if (
                                    typeof element.modelgroupnev === 'string'
                                    && typeof carData.tipus === 'string'
                                ) {
                                    if (element.modelgroupnev.toUpperCase() === carData.tipus.toUpperCase()) {
                                        gyartmanyHash = element.modelgroupkod;
                                    }
                                }
                            });
                            return eurotaxService.vehiclesByModelGroupWithExtras(
                                gyartmanyHash,
                                carData.fajta === MOTOR ? MOTOR : SZGK,
                                carData.gyartev,
                            )
                                .then((vehiclesByModelGroupWithExtrasResponse) => {
                                    this.cars = vehiclesByModelGroupWithExtrasResponse.data.vehicles;
                                    this.filteredCars = vehiclesByModelGroupWithExtrasResponse.data.vehicles;
                                    const filterArray = [];

                                    [
                                        'gyartev',
                                        'uzemanyag_kod',
                                        'hengerurtartalom',
                                        'teljesitmeny_kw',
                                        'ajtok_szama',
                                        'valto_tipusa',
                                        'ferohelyek_szama',
                                    ].forEach((field) => {
                                        if (carData[field]) {
                                            filterArray.push({
                                                name: field,
                                                input: (
                                                    field === 'hengerurtartalom'
                                                    || field === 'teljesitmeny_kw'
                                                        ? `${carData[field]}.00`
                                                        : carData[field]
                                                ),
                                            });
                                        }
                                    });

                                    this.filterCar(filterArray);

                                    this.loading = false;
                                    if (this.filteredCars.length !== 0) {
                                        this.$store.commit('setProp', {
                                            value: carData.gyartev,
                                            path: 'gepjarmu.gyartev',
                                        });
                                        this.$store.commit('setProp', {
                                            value: carData.rendszam,
                                            path: 'gepjarmu.rendszam',
                                        });
                                        this.stepper = 1;
                                        this.carDataStatusUpdate('finished');
                                    } else {
                                        this.$emit('no-car-found');
                                    }
                                });
                        });
                } else {
                    this.$emit('no-car-found');
                }
            });
        EventBus.$on('selected-car', (etaxcode) => {
            this.eurotaxcode = etaxcode;
        });
    },

    data() {
        return {
            icons: {
                mdiFilter,
                mdiClose,
            },
            loadedCarData: null,
            gyorsSzuroOpened: false,
            showAll: false,
            loading: false,
            currentStage: 1,
            eurotaxcode: null,
            cars: [],
            filteredCars: [],
            visibleCars: [],
            maxVisibleCars: 15,
            stepper: 1,
            filter: [],
            resetSelectedExtras: false,
            selectedGyartasiEv: null,
            showExtrasWarning: false,
        };
    },

    computed: {
        expansionHeader() {
            return '<p style="margin-bottom: 0px;"><v-btn class="button"><b>GyorsSzűrő</b></v-btn>: '
                + 'Lista szűkítése felszereltség alapján</p>';
        },
        getFilteredCarDb() {
            return this.filteredCars.length;
        },
    },

    methods: {
        goToStep(step) {
            if (this.stepper > step) {
                this.stepper = step;
            }
        },
        gyorsBtnClick() {
            this.gyorsSzuroOpened = this.gyorsSzuroOpened === 0 ? null : 0;
        },
        setGyartasiEv(gyartev) {
            this.selectedGyartasiEv = gyartev;
        },
        carDataStatusUpdate(status) {
            switch (status) {
            case 'finished':
                this.currentStage = 2;
                this.resetSelectedExtras = true;
                this.attachSpecialExtras(this.filteredCars);
                break;
            case 'in_progress':
                this.currentStage = 1;
                break;
            default:
                throw new Error('Something went wrong with carDataStatusUpdate');
            }
        },

        resetCars() {
            this.cars = [];
            this.filteredCars = [];
            this.visibleCars = [];
        },

        attachSpecialExtras(carList) {
            const specialInPool = findSpecialExtras(this.filteredCars);
            carList.forEach((car, index) => {
                this.filteredCars[index].special_extras = [];
                (car.extras || []).forEach((carExtra) => {
                    specialInPool.forEach((specialExtra) => {
                        if (carExtra.eq_code === specialExtra.eq_code) {
                            this.filteredCars[index].special_extras.push({
                                eq_code: specialExtra.eq_code,
                                name: specialExtra.name,
                                short_name: specialExtra.short_name,
                            });
                        }
                    });
                });
            });
        },

        chShowAll() {
            this.showAll = !this.showAll;
            this.visibleCars = this.getVisibleVehicleList(this.filteredCars);
        },

        filterCar(fields, loadFilter = false) {
            let filtered = this.cars;
            let clonedFields = fields;
            if (loadFilter) {
                clonedFields = this.filter.concat(clonedFields);
            } else {
                this.filter = clonedFields;
            }

            Object.keys(clonedFields)
                .forEach((key) => {
                    if (clonedFields[key].name !== 'extras') {
                        filtered = filtered.filter((car) => {
                            const inputData = clonedFields[key].input;
                            if (clonedFields[key].name === 'gyartev') {
                                const gyartBegin = car.gyartasi_ev_tol;
                                const gyartEnd = car.gyartasi_ev_ig;
                                const isBetween = () => {
                                    const isCarProductionFinished = () => !!gyartEnd;
                                    if (isCarProductionFinished()) {
                                        return inputData >= gyartBegin && inputData <= gyartEnd;
                                    }
                                    return inputData >= gyartBegin;
                                };
                                return isBetween();
                            }
                            return car[clonedFields[key].name] === inputData;
                        });
                    } else {
                        filtered = filtered.filter((car) => {
                            const selectedExtrasCount = clonedFields[key].input.length;
                            let extrasCount = 0;
                            (car.extras || []).forEach((carExtra) => {
                                clonedFields[key].input.forEach((filterExtra) => {
                                    if (carExtra.eq_code === filterExtra.eq_code) {
                                        extrasCount += 1;
                                    }
                                });
                            });
                            return selectedExtrasCount === extrasCount;
                        });
                    }
                });
            this.filteredCars = filtered;
        },

        getVisibleVehicleList(currentPool) {
            if (this.showAll) {
                return currentPool;
            }
            return currentPool.slice(0, this.maxVisibleCars);
        },
    },
};
</script>

<style>

.show-all-text {
    cursor: pointer;
    color: #2789c0;
}

.show-all-text:hover {
    text-decoration: underline;
}

.give-me-a-pointer {
    cursor: pointer;
}

html
body
div
div#app.application.theme--light
div.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content
div.v-select-list.v-card.theme--light
div.v-list.theme--light
div a.v-list__tile.v-list__tile--link.theme--light
div.v-list__tile__action {
    display: none !important;
}

</style>
